import { render, staticRenderFns } from "./Solution2.vue?vue&type=template&id=5b5c78dd&scoped=true"
import script from "./Solution2.vue?vue&type=script&lang=js"
export * from "./Solution2.vue?vue&type=script&lang=js"
import style0 from "./Solution2.vue?vue&type=style&index=0&id=5b5c78dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c78dd",
  null
  
)

export default component.exports